var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSongClaimSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.66663V7.33329H8.83333V11.0833C8.83325 11.5132 8.70016 11.9326 8.45234 12.2838C8.20451 12.6351 7.85408 12.9011 7.4491 13.0454C7.04412 13.1897 6.60443 13.2051 6.19032 13.0896C5.77622 12.9741 5.40799 12.7334 5.13612 12.4003C4.86426 12.0673 4.70208 11.6583 4.67183 11.2295C4.64158 10.8006 4.74474 10.3729 4.96716 10.005C5.18957 9.63713 5.52036 9.34704 5.91415 9.17456C6.30794 9.00208 6.74545 8.95564 7.16667 9.04163V5.66663H10.5V2.33329H2.16667V15.6666H13.8333V5.66663H11.3333ZM0.5 1.49329C0.5 1.03663 0.8725 0.666626 1.3325 0.666626H11.3333L15.5 4.83329V16.4941C15.5008 16.6036 15.48 16.7121 15.4388 16.8135C15.3976 16.9149 15.3369 17.0072 15.2601 17.0851C15.1832 17.163 15.0918 17.225 14.991 17.2676C14.8902 17.3102 14.7819 17.3325 14.6725 17.3333H1.3275C1.10865 17.3318 0.899181 17.2442 0.744348 17.0895C0.589515 16.9349 0.501746 16.7255 0.5 16.5066V1.49329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongClaimSelected);
export default __webpack_public_path__ + "static/media/song_claim_selected.8f107021ac7d157b6d57e5e4e40a5e47.svg";
export { ForwardRef as ReactComponent };